import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteprocessModal = ({ show, onHide, handleDelete, itemId }) => {
  const confirmDelete = () => {
    handleDelete(itemId);
    onHide(); // Close the modal after confirming
  };

  return (
    <Modal centered={true} show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to delete this item?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>Cancel</Button>
        <Button className="delete-btn btn-danger me-1" onClick={confirmDelete}>Delete</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteprocessModal;
